import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './App.css';

export default function AdminPanel() {
  const [formData, setFormData] = useState({
    title: '',
  content: '',
  answer: '',
  keywords: []
  });
  const [tempKeyword, setTempKeyword] = useState('');
  const [message, setMessage] = useState('');
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const handleAddKeyword = () => {
    if (tempKeyword && !formData.keywords.includes(tempKeyword)) {
      setFormData(prev => ({
        ...prev,
        keywords: [...prev.keywords, tempKeyword]
      }));
      setTempKeyword('');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (Object.keys(errors).length > 0) return;
    
    try {
      setMessage('提交中...');
      const controller = new AbortController();
      const timeoutId = setTimeout(() => {
        controller.abort();
        setMessage('请求超时，请检查网络连接');
      }, 10000);
      
      const response = await fetch(`https://www.cognospring.site/api/questions`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
          title: formData.title,
          content: formData.content,
          answer: formData.answer,
          keywords: formData.keywords
        }),
        signal: controller.signal
      });
      
      clearTimeout(timeoutId);
      const result = await response.json();
      if (response.ok) {
        setMessage(`${result.id} 创建成功！`);
        setTimeout(() => navigate('/'), 2000);
      } else if (response.status === 422) {
        const fieldErrors = {};
        result.detail.forEach(err => {
          const field = err.loc[1];
          fieldErrors[field] = err.msg;
        });
        setErrors(fieldErrors);
      } else if (response.status === 400) {
        setMessage(result.detail || '请求参数错误');
      } else {
        setMessage(result.detail || '提交失败');
      }
    } catch (error) {
      setMessage(error.name === 'AbortError' ? '请求超时' : '服务器连接失败');
    } finally {
      setFormData({ title: '', content: '', answer: '', keywords: [] });
      setTimeout(() => setMessage(''), 5000);
    }
  };

  return (
    <div className="admin-panel">
      <button onClick={() => navigate('/')} className="home-button">返回首页</button>
      <h2>新建海龟汤题目</h2>
      <form onSubmit={handleSubmit}>
        
        <div className="form-group">
  <label>标题:</label>
  <input
    value={formData.title}
    onChange={e => setFormData({...formData, title: e.target.value})}
    required
  />
</div>
{/* 在表单字段下方添加错误提示 */}
<div className="form-group">
  <label>问题描述:</label>
  <textarea
    value={formData.content}
    onChange={e => setFormData({...formData, content: e.target.value})}
    required
  />
  {errors.content && <div className="error-message">{errors.content}</div>}
</div>
<div className="form-group">
  <label>正确答案:</label>
  <textarea
    value={formData.answer}
    onChange={e => setFormData({...formData, answer: e.target.value})}
    required
  />
  {errors.answer && <div className="error-message">{errors.answer}</div>}
</div>
<div className="form-group">
  <label>关键词:</label>
  <div className="keyword-input">
    <input
      value={tempKeyword}
      onChange={e => setTempKeyword(e.target.value)}
      placeholder="输入关键词"
    />
    <button type="button" onClick={handleAddKeyword}>添加</button>
  </div>
  <div className="keywords-list">
    {formData.keywords.map((kw, index) => (
      <span key={index} className="keyword-tag">
        {kw}
      </span>
    ))}
  </div>
</div>
        <button 
          type="submit" 
          disabled={message.includes('成功') || message === '提交中...'}
        >
          {message === '提交中...' ? '提交中...' : '提交题目'}
        </button>
      </form>
      {message && <div className="message">{message}</div>}
    </div>
  );
}
